import { render, staticRenderFns } from "./managing_criteria.vue?vue&type=template&id=82b33d88&"
import script from "./managing_criteria.vue?vue&type=script&lang=js&"
export * from "./managing_criteria.vue?vue&type=script&lang=js&"
import style0 from "./managing_criteria.vue?vue&type=style&index=0&id=82b33d88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports